import { getContactLensById } from "@/services/getContactLensById";
import { useConfigStore, useContactLensesStore } from "@/store";
import { Attributes } from "@/types/config.types";
import { LensPrescription } from "@/types/prescription.types";
import { useEffect, useState } from "react";

const formatAttriburtes = (attributes: Attributes): LensPrescription => {
  return Object.entries(attributes).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      acc[key] = value[0];
      return acc;
    },
    {},
  );
};

export const usePrescriptionData = () => {
  const { config } = useConfigStore();
  const [prescription, setPrescription] = useState<any>(null);
  const { selectedPrescription } = useContactLensesStore();

  useEffect(() => {
    if (config && selectedPrescription) {
      const fetchPrescription = async () => {
        try {
          const rightData = await getContactLensById(
            config.storeId,
            config.catalogId,
            selectedPrescription.rightCatentryId.toString(),
            config.basePath,
          );
          const leftData = await getContactLensById(
            config.storeId,
            config.catalogId,
            selectedPrescription.leftCatentryId.toString(),
            config.basePath,
          );
          setPrescription({
            OD: formatAttriburtes(rightData.catalogEntry.attributes),
            OS: formatAttriburtes(leftData.catalogEntry.attributes),
          });
        } catch (error) {
          throw new Error(
            "Error retrieving lens data from prescription: " + error,
          );
        }
      };

      fetchPrescription();
    }
  }, [config, selectedPrescription]);

  return { prescriptionAttributes: prescription };
};
